import { useQuery } from "@tanstack/react-query";
import { SEO } from "../components/shared/SEO";
import { PageHeader } from "../components/shared/PageHeader";
import { Reveal } from "../components/shared/Reveal";
import { CTABand } from "../components/shared/Sections";
import { OperationCard } from "../components/operations/OperationCard";
import { api } from "../lib/api";

export default function Operazioni() {
  const { data: ops = [], isLoading } = useQuery({ queryKey: ["operations"], queryFn: () => api.get("/operations").then((r) => r.data) });
  const open = ops.filter((o) => o.status !== "conclusa"), closed = ops.filter((o) => o.status === "conclusa");
  return (
    <>
      <SEO title="Operazioni Immobiliari Aperte | Home Haven" description="Opportunità immobiliari selezionate, progettate e gestite da Home Haven: scopri le operazioni di valorizzazione attualmente aperte agli investitori." />
      <PageHeader eyebrow="Operazioni aperte" title="Operazioni immobiliari aperte" text="Opportunità immobiliari selezionate, progettate e gestite da Home Haven." compact />
      <section className="section bg-cream">
        <div className="container-hh">
          <Reveal className="max-w-3xl mb-16 md:mb-24">
            <p className="lead" data-testid="operations-intro">Individuiamo immobili con potenziale di valorizzazione, sviluppiamo il progetto, coordiniamo la trasformazione e accompagniamo ogni operazione fino alla sua conclusione.</p>
            <p className="font-serif text-2xl md:text-3xl font-light tracking-tight text-ink mt-8">Scopri le operazioni attualmente aperte.</p>
          </Reveal>
          {isLoading && <div className="text-stone text-sm uppercase tracking-widest">Caricamento…</div>}
          <div data-testid="operations-grid" className="grid grid-cols-1 md:grid-cols-2 gap-10">{open.map((o, i) => <OperationCard key={o.id} o={o} index={i} />)}</div>
          {!isLoading && open.length === 0 && <p data-testid="operations-empty" className="lead">Al momento non ci sono operazioni aperte. Lascia i tuoi riferimenti nell'area investitori per essere informato sulle prossime.</p>}
          {closed.length > 0 && (
            <div className="mt-24">
              <Reveal className="mb-12"><div className="eyebrow mb-4">Archivio</div><h2 className="h-section">Operazioni concluse.</h2></Reveal>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-10">{closed.map((o, i) => <OperationCard key={o.id} o={o} index={i} />)}</div>
            </div>
          )}
        </div>
      </section>
      <CTABand dark eyebrow="Investitori" title="Vuoi essere informato sulle prossime operazioni?" text="Raccontaci il tuo profilo: ti contatteremo in forma riservata quando una nuova operazione sarà disponibile." primary={{ to: "/investitori#contatto-investitori", label: "Parla con Home Haven", testId: "operations-cta-investitori" }} secondary={{ to: "/progetti", label: "Operazioni concluse", testId: "operations-cta-progetti" }} />
    </>
  );
}
